import { render, staticRenderFns } from "./ClientesComponent.vue?vue&type=template&id=62428482&scoped=true&"
import script from "./ClientesComponent.vue?vue&type=script&lang=js&"
export * from "./ClientesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientesComponent.vue?vue&type=style&index=0&id=62428482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62428482",
  null
  
)

export default component.exports